import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Register from './pages/Register';
import CubApplication from './pages/CubApplication';
import LionApplication from './pages/LionApplication';
import Donate from './pages/Donate';
import Donors from './pages/Donors';
import Mission from './pages/Mission';
import Team from './pages/Team';
import News from './pages/News';
import SuccessStories from './pages/SuccessStories';
import Benefits from './pages/Benefits';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import MentalHealthTeam from './pages/MentalHealthTeam';
import ContactUs from './pages/ContactUs';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Layout component to conditionally show header/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  return (
    <>
      {!isAdminRoute && <Header />}
      <main className={!isAdminRoute ? "pt-20" : ""}>
        {children}
      </main>
      {!isAdminRoute && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/register" element={<Register />} />
              <Route path="/register/cub" element={<CubApplication />} />
              <Route path="/register/lion" element={<LionApplication />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/donors" element={<Donors />} />
              <Route path="/mission" element={<Mission />} />
              <Route path="/team" element={<Team />} />
              <Route path="/mental-health-team" element={<MentalHealthTeam />} />
              <Route path="/news" element={<News />} />
              <Route path="/success-stories" element={<SuccessStories />} />
              <Route path="/benefits" element={<Benefits />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
            </Routes>
          </Layout>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;